const Loading = () => {
    return (
        <div className='bg-white/80 inset-0 w-full h-screen fixed z-20'>
            <div className='flex flex-col items-center justify-center w-full h-full'>
                <img className='w-8 h-8' src='/loading.svg' alt='Loading' />
                Cargando datos, por favor espere...
            </div>
        </div>
    )
}

export default Loading